import {Component, OnInit, QueryList, ViewChildren} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {SlownikService} from '../../../../../../../shared/services/slownik/slownik.service';
import {NavigationService} from '../../../../../../../shared/services/navigation/navigation.service';
import {SlownikUszkodzen} from '../../../../../../../shared/model/uszkodzenia/slownik-uszkodzen';
import {LokalizacjaUszkodzenia} from '../../../../../../../shared/model/uszkodzenia/lokalizacja-uszkodzenia';
import {Store} from '@ngrx/store';
import {
  FormularzUszkodzenService
} from '../../../../../../../shared/components/proces-uszkodzen/zgloszenie/ubezpieczenie/podsumowanie/lista-przedmiotow/rodzaj-elementu/uszkodzenia/formularz-uszkodzen.service';
import {BaseLokalizacjaUszkodzenComponent} from '../base-lokalizacja-uszkodzen.component';
import {
  ParametryPrzedmiotuSzklanego,
  ParametryZbioruUszkodzen
} from '../../../../../../../shared/store/zbior-uszkodzen/zbiorUszkodzen';
import {
  UszkodzeniaWLokalizacjiComponent
} from '../../../../../../../shared/components/proces-uszkodzen/zgloszenie/ubezpieczenie/podsumowanie/lista-przedmiotow/rodzaj-elementu/uszkodzenia/lokalizacja/uszkodzenia-w-lokalizacji.component';

@Component({
  selector: 'app-przedmioty-szklane',
  templateUrl: './przedmioty-szklane.component.html',
  styleUrls: ['przedmioty-szklane.component.scss']
})

export class PrzedmiotySzklaneComponent extends BaseLokalizacjaUszkodzenComponent implements OnInit {

  @ViewChildren(UszkodzeniaWLokalizacjiComponent) uszkodzenia!: QueryList<UszkodzeniaWLokalizacjiComponent>;

  private nazwaUszkodzenia!: string;

  constructor(route: ActivatedRoute, store: Store, navigation: NavigationService,
              formularzUszkodzenService: FormularzUszkodzenService,
              slownikService: SlownikService) {
    super(route, store, navigation, formularzUszkodzenService, slownikService);
    // ToDo - Wykorzystanie innego mechanizmu pobierania ścieżki z route?
    this.nazwaUszkodzenia = route.snapshot.url[0].path;
    this.sortujUszkodzeniaWgPriorytetowWyswietlania = false;
  }

  get slownikUszkodzen(): SlownikUszkodzen[] {
    return [SlownikUszkodzen.SZYBA_W_OKNIE_PAKIET_DWUSZYBOWY, SlownikUszkodzen.SZYBA_W_OKNIE_PAKIET_TRZYSZYBOWY, SlownikUszkodzen.OSZKLENIE_DRZWIOWE, SlownikUszkodzen.BIDET,
      SlownikUszkodzen.UMYWALKA, SlownikUszkodzen.LACOBEL, SlownikUszkodzen.ZLEWOZMYWAK,
      SlownikUszkodzen.SZYBA_KOMINKOWA, SlownikUszkodzen.MUSZLA_KLOZETOWA, SlownikUszkodzen.BRODZIK,
      SlownikUszkodzen.LUSTRO_STALE, SlownikUszkodzen.KABINA_PRYSZNICOWA, SlownikUszkodzen.PLYTA_INDUKCYJNA,
      SlownikUszkodzen.SZYBA_DO_PIEKARNIKA, SlownikUszkodzen.INNE];
  }

  get lokalizacjaUszkodzen(): LokalizacjaUszkodzenia {
    return LokalizacjaUszkodzenia.pobierz(this.nazwaUszkodzenia);
  }

  ngOnInit(): void {
    super.ngOnInit();
  }

  iniciujFormularz(): void {
    return;
  }

  zapiszUszkodzeniazPodformularzy(): void {
    const parametry = {} as ParametryZbioruUszkodzen;

    const wybraneUszkodzenia = this.uszkodzenia
      .filter((element) => (element.wszystkieWartosciWypelnione() || element.formularzUszkodzenia.valid) && element.czyUszkodzenieWybraneNaFormularzu())
    const uszkodzeniaPojedyncze = this.utworzUszkodzeniaPojedynczeDlaPrzedmiotowSzklanych<ParametryPrzedmiotuSzklanego>(wybraneUszkodzenia);
    const uszkodzeniaGrupowe = this.utworzUszkodzeniaGrupowe<ParametryPrzedmiotuSzklanego>(wybraneUszkodzenia);

    const uszkodzenia = uszkodzeniaPojedyncze.concat(uszkodzeniaGrupowe)
    this.utworzLubAktualizujZbiorUszkodzen(parametry, uszkodzenia);
  }

}
